// import React from "react";

// const Header = ({ name, weeksLeft, setShowModal }) => (
//   <>
//     <h1 className="text-3xl font-bold text-center mb-20 text-white">
//       Precious Time Tracker
//     </h1>
//     <p className="text-7xl font-serif text-center mb-20">
//       {name}, You have <span className="font-bold">{weeksLeft}</span> weeks
//       left. 😩
//       {/* (before 60) */}
//     </p>
//     <p className="text-6xl font-semibold text-gray-400 text-center mb-16 italic">
//       "Do
//       <span className="bg-gradient-to-r from-yellow-400 via-orange-500 to-red-600 bg-clip-text text-transparent p-3 font-bold">
//         Harsh
//       </span>
//        Work 💪"
//     </p>
//     <button
//       onClick={() => setShowModal(true)} // This will open the modal
//       className="block mx-auto mb-8 bg-white text-black font-bold px-6 py-4 rounded-full hover:bg-gray-100 hover:scale-105"
//     >
//       Make it for yourself!🚀
//     </button>
//   </>
// );

// export default Header;

import React from "react";
import OfferButton from "./Offer";

const Header = ({ name, weeksLeft, setShowModal }) => (
  <>
    <h1 className="text-3xl font-bold text-center mb-20 text-white">
      Precious Time Tracker
    </h1>
    <p className="text-5xl sm:text-7xl font-serif text-center mb-20">
      {name}, You have <span className="font-bold">{weeksLeft.toLocaleString()}</span> weeks
      left. 😩
      {/* (before 60) */}
    </p>
    <p className="text-4xl sm:text-6xl font-semibold text-gray-400 text-center mb-16 italic">
      "Do
      <span className="bg-gradient-to-r from-yellow-400 via-orange-500 to-red-600 bg-clip-text text-transparent p-3 font-bold">
        Harsh
      </span>
      Work 💪"
    </p>
    <button
      onClick={() => setShowModal(true)} // This will open the modal
      className="block mx-auto bg-white text-black font-bold px-4 sm:px-6 py-3 sm:py-4 rounded-full hover:bg-gray-100 hover:scale-105"
    >
      Make it for yourself!🚀
    </button>
    <span>
    <OfferButton />
    <button className="block mx-auto text-black font-bold px-4 sm:px-6 sm:py-4 rounded-full hover:scale-105">
      {/* <a
        href="https://www.producthunt.com/posts/lockedin-2?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-lockedin&#0045;2"
        target="_blank"
      > */}
        {/* <img
          src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=498442&theme=dark"
          alt="LockedIn - Count&#0032;Every&#0032;Weeks&#0044;&#0032;Live&#0032;with&#0032;Purpose&#0046; | Product Hunt"
        /> */}
      {/* </a> */}
      </button>
    </span>
    {/* <button className="block mx-auto text-black font-bold px-4 sm:px-6 sm:py-4 rounded-full hover:scale-105">
      <a
        href="https://www.producthunt.com/posts/lockedin-2?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-lockedin&#0045;2"
        target="_blank"
      >
        <img
          src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=498442&theme=dark"
          alt="LockedIn - Count&#0032;Every&#0032;Weeks&#0044;&#0032;Live&#0032;with&#0032;Purpose&#0046; | Product Hunt"
        />
      </a> */}
      {/* <a
        href="https://www.producthunt.com/posts/lockedin-2?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-lockedin&#0045;2"
        target="_blank"
      >
        <img
          src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=498442&theme=light"
          alt="LockedIn - Count&#0032;Every&#0032;Weeks&#0044;&#0032;Live&#0032;with&#0032;Purpose&#0046; | Product Hunt"
          width="250"
          height="54"
        />
      </a> */}
    {/* </button> */}
    {/* <a href="https://www.producthunt.com/posts/lockedin-2?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-lockedin&#0045;2" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=498442&theme=dark" alt="LockedIn - Count&#0032;Every&#0032;Weeks&#0044;&#0032;Live&#0032;with&#0032;Purpose&#0046; | Product Hunt" style="width: 250px; height: 54px;" width="250" height="54" /></a> */}
  </>
);

export default Header;
